
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';

import { DocumentQuery } from '../documentViewer/graphql';
import { TicketStatusQuery } from '../ticketApprovals/graphql/TicketStatusQuery';
import omitProps from '../../utils/omitProps';
import queryMetaHandler from '../../utils/queryMetaHandler';

export const updateCachedDocument = async (client, documentId) => {
  const variables = {
    documentId,
  };
  const response = await client.query({
    query: DocumentQuery, fetchPolicy: 'network-only', variables, errorPolicy: 'all',
  });

  await client.writeQuery({ query: DocumentQuery, data: response.data });
};

export const updateTicketReviewState = async (client, ticketId) => {
  const variables = {
    ticketId,
  };
  const response = await client.query({
    query: TicketStatusQuery, fetchPolicy: 'network-only', variables, errorPolicy: 'all',
  });

  client.writeQuery({ query: TicketStatusQuery, data: response.data });
};

const TicketDocumentQuery = gql`
  query TicketDocuemnt($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      id
      ticketNumber: ticket_number {
        id
        documentId: document_id
      }
    }
  }
`;

const mapDataToProps = withProps((props) => {
  const { documentId } = props.data.ticket.ticketNumber;
  return {
    documentId,
  };
});

const queryTicketDocument = graphql(TicketDocumentQuery);

export const queryTicketDocumentGQL = compose(
  queryTicketDocument,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);
